<p-table [columns]="cols"
         [value]="allergenesSupplier.allergenes"
         [totalRecords]="totalRecords"
         [scrollHeight]="utils.scrollHeightContent(204)"
         styleClass="p-datatable-sm"
         [scrollable]="true"
         dataKey="id"
         #dt>

  <!--COLGROUP-->
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">

        <col *ngSwitchCase="'allergene.libelle'" [style.min-width.px]="300" [style.max-width.px]="300"
             [style.text-align]="'left'">
        <col *ngSwitchCase="'allergene.logo'" [style.min-width.px]="80" [style.max-width.px]="80"
             [style.text-align]="'center'">
        <col *ngSwitchDefault [style.min-width.px]="200" [style.max-width.px]="200" [style.text-align]="'center'">

      </ng-container>

    </colgroup>
  </ng-template>


  <!--HEADER-->
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let col of columns; trackBy:utils.trackByFn">
        <ng-container [ngSwitch]="col.field">

          <ng-container *ngSwitchCase="'allergene.libelle'">
            <th [style.min-width.px]="300" [style.max-width.px]="300">
              <ng-container *ngIf="!allergenesSupplier.isProduitFabrique">
                <p-checkbox class="mg-r-5" [(ngModel)]="selectAll" (onChange)="updateSelectAll($event)"
                            label=""
                            [disabled]="!canModify()"
                            binary="true"></p-checkbox>
              </ng-container>
              {{col.header}}
            </th>
          </ng-container>

          <ng-container *ngSwitchCase="'allergene.logo'">
            <th [style.min-width.px]="80" [style.max-width.px]="80">
              {{col.header}}
            </th>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <th [style.min-width.px]="200" [style.max-width.px]="200">
              {{col.header}}
            </th>
          </ng-container>

        </ng-container>
      </ng-container>
    </tr>
  </ng-template>

  <!--BODY-->
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [class.incomplete]="rowData.code==='NONRENS'">

      <ng-container *ngFor="let col of columns;  trackBy:utils.trackByFn">


        <ng-container [ngSwitch]="col.field">

          <!--ALLERGENES-->
          <ng-container *ngSwitchCase="'allergene.libelle'">

            <td [style.max-width.px]="300" [style.min-width.px]="300">
              <ng-container *ngIf="!allergenesSupplier.isProduitFabrique">
                <p-checkbox [ngModel]="getActiveRow(rowData.id)"
                            class="mg-r-5"
                            [disabled]="!canModify()"
                            (ngModelChange)="setActiveRow(rowData.id,$event)"
                            binary="true"></p-checkbox>
              </ng-container>

              <strong>{{rowData.libelle | uppercase}}</strong>
            </td>
          </ng-container>

          <!--PHOTO-->
          <ng-container *ngSwitchCase="'allergene.logo'">
            <td [style.max-width.px]="80" [style.min-width.px]="80">
              <yo-img-entity [displayNoImage]="true"
                             format="thumb"
                             [entityId]="rowData.id"
                             [entityName]="allergeneEntityName"
                             [refresh]="refreshImg"
                             [ordre]="1"
                             [openable]="true"
                             [height]="32"
                             [title]="rowData.libelle"
                             class="mg-r-5"
              ></yo-img-entity>
            </td>
          </ng-container>

          <!--DÉCLINAISONS-->
          <ng-container *ngSwitchDefault>
            <td [style.max-width.px]="200" [style.min-width.px]="200">
              <div class="text-center">
                <p-checkbox [ngModel]="getActiveProduitAllergene(rowData.id,col.field)"
                            (ngModelChange)="setActiveProduitAllergene(rowData.id,col.field,$event)"
                            [disabled]="!canModify()"
                            binary="true">
                </p-checkbox>
              </div>
            </td>
          </ng-container>

        </ng-container>
      </ng-container>
    </tr>
  </ng-template>
</p-table>

<div class="d-flex mg-t-5">
  <div class="mr-auto">
    <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
    <em class="mg-r-10">Sélectionner les allergènes...</em>
    <span class="genlabel font-12 pd-t-10" *ngIf="allergenesSupplier.isProduitFabrique">
          <i class="fas fa-exclamation-triangle danger-color mg-r-5"></i>
           Les allergènes des produits fabriqués ne sont pas modifiables. Ils sont calculés à partir des denrées composant le
      plat. La mise à jour est faite une fois par jour pendant la nuit par Datameal Online.
  </span>
  </div>
  <div class="mg-r-5">
    <yo-button buttonClass="cta-success" iconClass="fas fa-save" (onClick)="save()" [disabled]="!canModify()" tooltip="Enregistrer"></yo-button>
  </div>
  <div>
    <yo-button iconClass="fas fa-times" tooltip="Fermer" (onClick)="utils.sidenav=false"
            buttonClass="cta-inner-delete"></yo-button>
  </div>
</div>
